
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { BiInfoCircle } from 'react-icons/bi'
import { getFormattedOnlyDate  } from '../../../../utils/common-methods'



const VehicleNRNTooltip = ({parameter1,parameters=[] , placement  = 'auto-end' }) => {
  const isMultiple = parameters.length >= 1;
  const renderTooltip = (props) => (
    <Tooltip
      className={isMultiple ? 'vehicle-nrn-tooltip multi-tooltip' : 'vehicle-nrn-tooltip single-tooltip'}
      {...props}
    >
      {isMultiple ? (
    <table className="tooltip-table">
      <tbody>
         <tr  >
            <th style={{ textAlign: 'center', paddingRight: '8px' }}>Vehicle No.</th>
            <th style={{ textAlign: 'center', paddingRight: '8px' }}>Location</th>
            <th style={{ textAlign: 'center', paddingRight: '8px' }}>Last Updated</th>
            <th style={{ textAlign: 'center', paddingRight: '8px' }}>RTO Changed</th>
          </tr>
         {parameters.map((param, index) => (
        <tr key={index} >
            <td style={{ textAlign: 'center', paddingRight: '8px' }}>{param.registration_number}</td>
            <td style={{ textAlign: 'center', paddingRight: '8px' }}>{param.location}</td>
            <td style={{ textAlign: 'center', paddingRight: '8px' }}>{param?.createdAt?getFormattedOnlyDate(param?.createdAt):'-'}</td>
            <td style={{ textAlign: 'center', paddingRight: '8px' }}>{param?.rrd?getFormattedOnlyDate(param?.rrd):'-'}</td>
          </tr>
          ))}
           </tbody>
    </table>
  ) 
  : <div><strong>New Vehicle No:</strong> {parameter1}</div>
  }
    </Tooltip>  
  )

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show:100, hide: 0 }}
      overlay={renderTooltip}
    >
      <button className="row-btn vehicle-nrn-tooltip">
        <BiInfoCircle className="row-i-icon" />
      </button>
      
    </OverlayTrigger>
  )
}

export default VehicleNRNTooltip